declare global {
  interface Window {
    __MM_VERSION?: string;
  }
}

window.__MM_VERSION = '2.5.0-popup-fix';

export {};
